import { Colors, Services } from '@sigma-frontend-libs/commons'
import { DICTIONARIES_STATUSES } from '@sigma-legacy-libs/essentials/lib/constants'

import { buttonModes, components } from '@/utils'

import button from '@/components/button'
import empty from '@/components/services/dictionaries/empty'
import sticker from '@/components/sticker'

const headers = [ 'number', 'prefix', 'operator', 'mcc', 'mnc', 'region' ]

function renderSearchField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.searchQuery,
        label: this.getTranslate('commons.labels.search'),
        loading: this.loading,
        clearable: true,
        dense: true,
        details: false
      },
      on: {
        input: event => {
          this.searchQuery = event
        }
      }
    }
  )
}
function renderSubmitButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('commons.labels.search'),
        mode: buttonModes.flat,
        color: Colors.primary,
        loading: this.loading,
        disabled: this.loading || !this.validation,
        type: 'submit'
      }
    }
  )
}
function renderForm(h) {
  return h(
    components.form,
    {
      class: `${Services.dictionaries}-search__form`,
      on: {
        submit: () => {
          this.search()
        }
      }
    },
    [
      renderSearchField.call(this, h),
      renderSubmitButton.call(this, h)
    ]
  )
}
function renderEmpty(h) {
  let state = 'default'
  if (this.empty) {
    state = 'search'
  }

  return h(
    empty,
    {
      props: {
        state
      }
    }
  )
}

function renderResult(h) {
  if (this.searchResult) {
    return h(
      'div',
      {
        class: `${Services.dictionaries}-search__result`
      },
      [
        headers.map(header => {
          if (this.searchResult[header]) {
            return h(
              sticker,
              {
                props: {
                  value: this.searchResult[header],
                  label: this.getTranslate(`${Services.dictionaries}.labels.${header}`),
                  copy: true
                }
              }
            )
          }
        })
      ]
    )
  }

  return renderEmpty.call(this, h)
}
function renderContent(h) {
  return h(
    components.card,
    {
      class: `${Services.dictionaries}-search__body`,
      props: {
        outline: true,
        dashed: true,
        rounded: true
      }
    },
    [ renderResult.call(this, h) ]
  )
}

export default function(h) {
  if ([ DICTIONARIES_STATUSES.compiled, DICTIONARIES_STATUSES.activated ].includes(this.dictionary.status)) {
    return h(
      'div',
      {
        class: `${Services.dictionaries}-search`
      },
      [
        renderForm.call(this, h),
        renderContent.call(this, h)
      ]
    )
  }
}
